import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, getUserProfile, uploadFileImage, updateUserProfile, updateUserEmail, updateUserPassword } from '../../../../services/services';
import Card from "../../../MyUI/Card/Card";
import Dialog from "../../../MyUI/Dialog/Dialog";
import EditableForm from "../../../MyUI/EditableForm/EditableForm";
import FileInput from "../../../MyUI/FileInput/FileInput";

const MAX_SIZE = 2 * 1024 * 1024;

export default function MyProfile() {
  const [loading, setLoading] = useState(true);
  const [formParams, setFormParams] = useState([{}]);

  const [collapsed, setCollapsed] = useState(false);
  const toggleCard = () => setCollapsed((p) => !p);

  const [user, setUser] = useState({ phone_number: "" });
  const [fileToUpload, setFileToUpload] = useState(null);
  const [fileErrorMessage, setFileErrorMessage] = useState("");
  
  const [changeEmail, setChangeEmail] = useState(false);
  const [changePassword, setChangePassword] = useState(false);
  const [ChangeInfo, setChangeInfo] = useState(false);
  
  const [imageUrl, _setImageUrl] = useState("");
  const [message, setMessage] = useState("");

  const setImageUrl = (relativeUrl) => {
    _setImageUrl(getFullImageUrl(relativeUrl));
  }; 
  
  const getFullImageUrl = (relativeUrl) => {
  if (!relativeUrl) return "";

  const mediaBaseUrl = api.defaults.baseURL.replace("/api", "");
  return `${mediaBaseUrl.replace(/\/$/, "")}/${relativeUrl.replace(/^\//, "")}`;
  };

 const genders = [
  { label: "Male", value: "Male" },
  { label: "Female", value: "Female" },
  { label: "Non-binary", value: "Non-binary" },
  { label: "Prefer not to say", value: "Prefer not to say" },
  { label: "Self-describe", value: "Self-describe" },
];


  const formFields = [
    { key: "address", label: "address", type: "input" },
    { key: "gender", label: "gender", type: "select", SELECT_OPTIONS:genders, placeholder:'choose your gender' },
    { key: "phone_number", label: "phone_number", type: "input", validation: ["phone_number"] },
  ];

  const idField = "id";
  const services= {
    update: updateUserProfile,
    services_url_names: {
    update: "updateUser_MyProfile",
    },
  }

  const formFields2 = [
    { key: "email", label: "email", type: "input", validation: ["required", "email"] },
  ];

  const services2 = {
    update: updateUserEmail,
    services_url_names: {
    update: "updateUser_MyProfile_Email",
    },
      
  }

  const formFields3 = [
    { key: "password", label: "New Password", type: "password", validation: ["required"] },
    { key: "password2", label: "Confirm Password", type: "password", validation: ["required"] },
  ];

  const services3 = {
    update: updateUserPassword,
    services_url_names: {
    update: "updateUser_MyProfile_Password",
    },
  }
    
  /* ---------------- LOAD USER ---------------- */
  useEffect(() => {
    getUser();
  }, []);

  const getUser = async () => {
      setLoading(true);
      try {
        const params = { username: localStorage.getItem("username") };
        const res = await getUserProfile(params);
        setUser(res.data);
        setFormParams([res.data]);
        setImageUrl(res.data.profile_picture);
      } catch (err) {
        console.error(err);
        setUser(null);
        console.error(`Error fetching user`, err);
      } finally {
        setLoading(false);
      }
    };
  /* ---------------- FILE VALIDATION ---------------- */
  const validateImage = (file) => {
    if (file && file.size > MAX_SIZE) {
      setFileErrorMessage("File size must be less than 2MB!");
      setFileToUpload(null);
    } else {
      setFileErrorMessage("");
      setFileToUpload(file);
    }
  };


  /* ---------------- CLOSE DIALOG ---------------- */
  const closeDialog = () => {
    setChangeEmail(false);
    setChangePassword(false);
    setChangeInfo(false);
  };

  const [messageKey, setMessageKey] = useState(0);

  return (
    <Card title="" collapsed={collapsed} toggleCard={toggleCard} showChevron>
        
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "16px"
          }}
        >
          <h2 style={{ "marginBottom": "40px" }}>Informations</h2>

          <div key={messageKey} className="message animate">
            {message}
          </div>

          {imageUrl && (
            <div className="center">
              <img
                src={imageUrl}
                alt="Profile"
                style={{
                  width: 220,
                  height: 220,
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />
            </div>
          )}

          {fileErrorMessage && <p className="error">{fileErrorMessage}</p>}

          <FileInput
            isBulk={false}
            labelSingle={`Upload profile picture ...`}
            accept="image/*"
            onChange={(e) => validateImage(e.target.files[0])}
            uploadService={uploadFileImage}
            setImageUrl={setImageUrl}
            onUploadComplete={(status) => console.log("Single file status:", status)}
          />

          <p>{user.username}</p>
          <p>{user.email} <button className="default-btn" onClick={() => {setFormParams([user]);setChangeEmail(true)}}>✏️</button></p>

          <button className="default-btn" onClick={() => {setFormParams([user]);setChangePassword(true)}}>
            Change my password
          </button>

          <button className="default-btn" onClick={() => {setFormParams([user]);setChangeInfo(true)}}>
            Change my info
          </button>
        
        {/* Info MODAL */}
        <Dialog open={ChangeInfo} onClose={() => closeDialog()}>
          <EditableForm
            params={formParams}
            setParams={setFormParams}
            state="edit"
            title="updateUserProfile"
            columns={formFields}
            saveButtonName={"Save"}
            services={services}       
            idField={idField}         
            refParam={null}   
            onClose={() => closeDialog()}
            onSaved={(f) => {getUser();setMessage(f.message);setMessageKey(prev => prev + 1)}}
          />
        </Dialog>

          <button className="label-btn">
            <Link to="/profile" className="btn-link">Back</Link>
          </button>


        {/* EMAIL MODAL */}
        <Dialog open={changeEmail} onClose={() => closeDialog()}>

          <EditableForm
              params={formParams}
              setParams={setFormParams}
              state="edit"
              title="setUserNewEmail"
              columns={formFields2}
              saveButtonName={"Save"}
              services={services2}       
              idField={idField}         
              refParam={null}   
              onClose={() => closeDialog()}
              onSaved={(f) => {getUser();}}
            />
        </Dialog>

        {/* PASSWORD MODAL */}
        <Dialog open={changePassword} onClose={() => closeDialog()}>

            <EditableForm
              params={formParams}
              setParams={setFormParams}
              state="edit"
              title="changePassword"
              columns={formFields3}
              saveButtonName={"Save"}
              services={services3}       
              idField={idField}         
              refParam={null}   
              onClose={() => closeDialog()}
              onSaved={(f) => {getUser();closeDialog();}}
            /> 
        </Dialog>
        
      </div>
    </Card>
  );
}
